import BTDrawer from '@common-components/bt-drawer/bt-drawer';
import { Close } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { taskActions } from '@common-reducers/TasksReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import MyWorkFilter from './my-work-filter';

export default function MyWorkCustomizeDrawer() {
    const dispatch = useAppDispatch();

    const taskViewSideDrawerOpen = useAppSelector(
        (state) => state.TasksReducer.taskViewSideDrawerOpen
    );


    function closeTaskViewSideDrawer() {
        dispatch(taskActions.setTaskViewSideDrawerOpenWith(""));
    }


    return (
        <BTDrawer variant={"persistent"} anchor="right" open={taskViewSideDrawerOpen !== ""}>
        <Box sx={{
            overflow: "auto",
            height: "100%",
            width: { xs: '100vw', sm: 450 },
            background: "var(--tasks-group-bg)",
            padding: "0 20px"
        }}>

            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "spaceBetween",
                height: "60px",
                position: "relative"
            }}>
                <IconButton onClick={closeTaskViewSideDrawer}>
                    <Close />
                </IconButton>
            </div>
            {taskViewSideDrawerOpen === "my-work-filter" && <MyWorkFilter />}
        </Box>
    </BTDrawer>
    );
}
